import { Box, List, ListItemText, ListItemIcon, ListItem, Collapse } from '@material-ui/core'
import { FunctionComponent } from 'react'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useHistory } from 'react-router-dom'
import { ExpandIcon } from './ExpandIcon'
import { useAnalytics, AnalyticUserType } from 'hooks/use-analytics/useAnalytics'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { StyledEventButton, StyledHomeButton, StyledListItem, StyledProductButton, useStyles } from './styled'
import { DEV_ONLY } from 'common/globalConstants'
import { AdminDrawerCollapsable } from './AdminDrawerCollapsable'
import { observer } from 'mobx-react'
import { AdminDrawerStore, GroupItemName } from './models/AdminDrawerStore'

interface AdminDrawerProps {
  AdminDrawerState: AdminDrawerStore
}

export const AdminDrawer: FunctionComponent<AdminDrawerProps> = observer(({ AdminDrawerState }) => {
  const theme = useTheme()
  const classes = useStyles()
  const { linkHierarchy } = AdminDrawerState

  const { backendUser, backendPartner, backendUserFunctions } = useAuth()
  const { handleTracker } = useAnalytics()

  const hasCreateEventPermission = backendUserFunctions?.find(userFunction => userFunction?.name === 'Create Event(s)')
  const hasUserGroupManagementPermission = backendUserFunctions?.find(
    userFunction => userFunction?.actionGroup === 'User Group Management'
  )
  const hasUserActionPermission = backendUserFunctions?.find(userFunction => userFunction?.name === 'User Action(s)')
  const ticketManagementPermissions = getUnique('Ticket Management')

  function getUnique(permission: string) {
    return backendUserFunctions?.filter(permissionObject => permissionObject?.actionGroup === permission)
  }

  return (
    <Box display="flex" color={theme.colors.accent1} bgcolor={theme.colors.backgroundII}>
      <List component="nav" className={classes.root} style={{ marginBottom: '100px' }}>
        <AdminDrawerCollapsable {...linkHierarchy.get(GroupItemName.HOME)} icon={<StyledHomeButton />} />

        {hasUserGroupManagementPermission && (
          <AdminDrawerCollapsable
            {...linkHierarchy.get(GroupItemName.USER_GROUP_MANAGEMENT)}
            icon={<StyledProductButton />}
          />
        )}
        {hasCreateEventPermission && (
          <AdminDrawerCollapsable {...linkHierarchy.get(GroupItemName.EVENT_MANAGEMENT)} icon={<StyledEventButton />} />
        )}
        {DEV_ONLY && (
          <AdminDrawerCollapsable
            {...linkHierarchy.get(GroupItemName.MEMBER_MANAGEMENT)}
            icon={<StyledProductButton />}
            onListItemClick={async (subItem) => {
              const logData = {
                'User ID': backendUser?.id,
                'Partner ID': backendPartner?.id,
                'Company Name': backendPartner?.name,
                'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role
              }

              await handleTracker(AnalyticUserType.ADMIN, subItem.name, logData, 'mixpanel', null, backendUser)
            }}
          />
        )}

        {ticketManagementPermissions?.length > 0 && (
          <AdminDrawerCollapsable
            key={GroupItemName.TICKET_MANAGEMENT}
            groupName={GroupItemName.TICKET_MANAGEMENT}
            groupItems={ticketManagementPermissions}
            icon={<StyledProductButton />}
          />
        )}
      </List>
    </Box>
  )
})